module.exports = __webpack_public_path__ + "img/paynehall-h-474x356.4e3d7689.jpg";